/* eslint-disable indent */
import React, { useEffect, useRef, useState } from 'react';
import {
  CockpitMode,
  MapVehicleListResponse,
  TakeOverSource,
  TakeOverSourceText,
  TakeOverStatus,
  VehicleLitResponse,
} from '@/utils/type';
import {
  isEmpty,
  stringToEnum,
  translatorEnum,
  convertSpeedMsToKmh,
} from '@/utils/util';
import './index.scss';
import classNames from 'classnames';
import MqttVideoPlayer from '@/components/VideoPlayer';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import OperationBtn from '@/components/OperationBtn';
import recovery from '@/assets/images/patrolMode/recovery.png';
import report from '@/assets/images/patrolMode/report.png';
import reportHover from '@/assets/images/patrolMode/reportHover.png';
import temporaryStop from '@/assets/images/patrolMode/temporaryStop.png';
import temporaryStopHover from '@/assets/images/patrolMode/temporaryStopHover.png';
import {
  VehicleScheduleState,
  VehicleState,
  sceneNameMap,
} from '@/utils/constant';
import BussinessApi from '@/fetch/bussiness';
import { useNavigate } from 'react-router-dom';
import CommonForm from '@/components/CommonForm';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import Modal from 'antd/es/modal/Modal';
import QuadVideoPlayer, { Direction } from '@/components/MultiVideoPlayer';
const fetchApi = new BussinessApi();
const formField: FormConfig = {
  data: [
    {
      cmpType: 'textarea',
      label: '备注',
      placeholder: '请输入',
      max: 50,
      fieldName: 'remark',
      maxLength: 50,
    },
  ],
};
export const AlarmCard = (props: any) => {
  const timerRef = useRef<any>(null); // Changed from let timer to const timerRef
  const alarmTime =
    typeof props.vehicleData.reportTime === 'number'
      ? props.vehicleData.reportTime
      : new Date(props.vehicleData.reportTime).getTime();
  const [nowTime, setNowTime] = useState<any>(new Date().getTime());

  const transTimeStamp = (value: number) => {
    if (value < 60000) {
      return '1min';
    } else if (value >= 60000 && value < 3600000) {
      return `${Math.floor(value / 60000)}min`;
    } else if (value >= 3600000 && value < 86400000) {
      const t1 = Math.floor(value / 3600000);
      const t2 = Math.floor((value % 3600000) / 60000);
      return `${t1}h${t2}min`;
    }
    return '24h+';
  };

  useEffect(() => {
    // 只有当 alarmTime 有效时才开启定时器
    if (!alarmTime) return;

    const timer = setInterval(() => {
      setNowTime(Date.now());
    }, 60000);

    return () => clearInterval(timer); // 严格清理
  }, [alarmTime]); // 仅在报警时间变化时重新计时

  return (
    <div className="alarm-card-container">
      <span className="triangle"></span>
      {props.vehicleData.alarmEvent && (
        <p className="alarm-title">
          {translatorEnum('ALARM_EVENT_ENUM', props.vehicleData.alarmEvent)}
        </p>
      )}
      {nowTime - alarmTime >= 0 && (
        <p className="alarm-time">{`<${transTimeStamp(
          nowTime - alarmTime
        )}`}</p>
      )}
    </div>
  );
};
export const IconLabel = (type: any) => {
  switch (type) {
    case 'speed':
      return (
        <img
          src={require('@/assets/images/collectMap/speed-icon.png')}
          style={{ width: '27px', height: '27px', marginRight: '10px' }}
        ></img>
      );
    case 'vehicleState':
      return (
        <img
          src={require('@/assets/images/collectMap/vehicle-state-icon.png')}
          style={{ width: '27px', height: '27px', marginRight: '10px' }}
        ></img>
      );
    case 'mileage':
      return (
        <img
          src={require('@/assets/images/collectMap/mileage-icon.png')}
          style={{ width: '27px', height: '27px', marginRight: '10px' }}
        ></img>
      );
    case 'freeSize':
      return (
        <img
          src={require('@/assets/images/collectMap/free-size-icon.png')}
          style={{ width: '27px', height: '27px', marginRight: '10px' }}
        ></img>
      );
    case 'bindingState':
      return (
        <img
          src={require('@/assets/images/collectMap/binding-state-icon.png')}
          style={{ width: '27px', height: '27px', marginRight: '10px' }}
        ></img>
      );
    default:
      return <></>;
  }
};
export const FieldItem = (props: {
  label: string | React.ReactNode;
  value?: string;
  isActive?: any;
}) => {
  return (
    <>
      <span className="field-item">
        <span className="field-title">{props.label}</span>
        <span
          className={classNames('field-content', {
            'active-field-content': props.isActive,
          })}
        >
          {props.value ?? '--'}
        </span>
      </span>
    </>
  );
};
interface Props {
  vehicleData: VehicleLitResponse | MapVehicleListResponse;
  otherStyle?: React.CSSProperties;
  url: string | undefined | null | any;
  collectVideoUrl: string | undefined | null | any;
  cockpitMode: CockpitMode;
  handleUpdate?: AnyFunc;
  isActive: boolean;
}

const VehicleCard = (props: Props) => {
  const navigate = useNavigate();
  const callFrontBtnClick = useRef<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const formInstance = useRef<any>(null);
  const containerRef = useRef<HTMLLIElement>(null);
  const { LC_BUTTON_R2, LC_BUTTON_R3 } = useSelector(
    (state: RootState) => state.controlBtn
  );
  const { vehicleData, otherStyle, url, handleUpdate, collectVideoUrl } = props;
  const [show, setShow] = useState(props.isActive);
  const isUnmounted = useRef(false);
  useEffect(() => {
    setShow(props.isActive);
  }, [props.isActive]);
  useEffect(() => {
    return () => {
      isUnmounted.current = true;
      // 显式清理掉当前组件持有的引用
      (containerRef.current as any) = null;
    };
  }, []);

  const temporyStop = async () => {
    try {
      const res = await fetchApi.temporaryStop({
        vehicleName: vehicleData.vehicleName,
        commandSource: TakeOverSource.REMOTE_JOYSTICK,
        timeStamp: Date.now(),
      });
      if (res?.code === HttpStatusCode.Success) {
        message.success(`${vehicleData.vehicleName}临时停车成功！`);
        handleUpdate && handleUpdate();
      } else {
        message.error(res?.message || '网络请求错误！');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const vehicleRecovery = async () => {
    try {
      const res = await fetchApi.vehicleRecovery({
        vehicleName: vehicleData.vehicleName,
        timeStamp: Date.now(),
      });
      if (res.code === HttpStatusCode.Success) {
        message.success(`${vehicleData.vehicleName}恢复成功！`);
        handleUpdate && handleUpdate();
      } else {
        message.error(res.message || '网络请求错误！');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const sendCallFrontCommand = () => {
    const value = formInstance.current?.getFieldsValue();
    fetchApi
      .reportManualAlarm({
        vehicleName: vehicleData.vehicleName,
        remark: value?.remark,
      })
      .then((res) => {
        if (isUnmounted.current) return;
        if (res.code === HttpStatusCode.Success) {
          message.success('上报成功！');
        } else {
          message.error(res.message);
        }
        setShowModal(false);
        callFrontBtnClick.current = false;
      });
  };

  const btnList = [
    vehicleData?.takeOverStatus === TakeOverStatus.TEMPORARY
      ? {
          onClick: vehicleRecovery,
          label: '恢复',
          defaultIcon: recovery,
          hoverIcon: recovery,
        }
      : {
          onClick: temporyStop,
          label: '临时停车',
          defaultIcon: temporaryStop,
          hoverIcon: temporaryStopHover,
        },
    {
      onClick: () => {
        setShowModal(true);
      },
      label: '呼叫远驾',
      defaultIcon: report,
      hoverIcon: reportHover,
    },
  ];

  const handleClose = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (LC_BUTTON_R2) {
      if (!props.isActive || props.cockpitMode !== CockpitMode.PATROL_MODE) {
        return;
      }
      const cb = btnList[0].onClick;
      cb();
    } else if (LC_BUTTON_R3) {
      if (!props.isActive || props.cockpitMode !== CockpitMode.PATROL_MODE) {
        return;
      }
      const cb = btnList[1].onClick;
      if (!callFrontBtnClick.current) {
        callFrontBtnClick.current = true;
        cb();
      } else {
        sendCallFrontCommand();
      }
    }
  }, [LC_BUTTON_R2, LC_BUTTON_R3]);
  const handleCardClick = (e: React.MouseEvent) => {
    if (props.cockpitMode === CockpitMode.PATROL_MODE) return;
    e.stopPropagation();

    setTimeout(() => {
      navigate('/app/singleview?vehicleName=' + vehicleData.vehicleName);
    }, 0);
  };

  return (
    <li
      ref={containerRef}
      className={classNames('vehicle-container', {
        'vehicle-item-active': props.isActive === true,
      })}
      style={otherStyle}
      onMouseEnter={() => {
        setShow(true);
      }}
      onMouseLeave={() => {
        if (props.isActive) {
          return;
        }
        setShow(false);
      }}
      onClick={handleCardClick}
    >
      <div className="video-container multi-video-item">
        {url && props.cockpitMode !== CockpitMode.MAP_COLLECTION_MODE && (
          <MqttVideoPlayer
            key={vehicleData.vehicleName}
            videoUrl={url}
            videoId={0}
            showVideoId={0}
            vehicleName={vehicleData.vehicleName}
          />
        )}
        {props.cockpitMode === CockpitMode.MAP_COLLECTION_MODE && (
          <QuadVideoPlayer
            videoSources={[
              { url: collectVideoUrl?.front || '', direction: Direction.FRONT },
              { url: collectVideoUrl?.back || '', direction: Direction.BACK },
              { url: collectVideoUrl?.left || '', direction: Direction.LEFT },
              { url: collectVideoUrl?.right || '', direction: Direction.RIGHT },
            ]}
          />
        )}
        <div className="top-vehicleData-container">
          <span className="vehicle-name">{vehicleData.vehicleName}</span>
          <span className="station-name">{vehicleData.stationName}</span>
        </div>
        {!url && props.cockpitMode !== CockpitMode.MAP_COLLECTION_MODE && (
          <div className="video-load-failed">
            <img
              src={require('@/assets/images/mutilVehicle/video-failed.png')}
            />
            <i>无法获取视频</i>
          </div>
        )}
        {vehicleData.takeOverUserName && (
          <div
            className={classNames('take-over', {
              temporaryStop:
                vehicleData.takeOverStatus === TakeOverStatus.TEMPORARY,
              takerOver: vehicleData.takeOverStatus === TakeOverStatus.TAKEOVER,
            })}
          >
            <i className="ico">
              {vehicleData.takeOverStatus === TakeOverStatus.TEMPORARY ? (
                <img
                  style={{ width: '25px', height: '25px' }}
                  src={require('@/assets/images/mutilVehicle/takeover.png')}
                />
              ) : (
                <img
                  style={{ width: '25px', height: '25px' }}
                  src={require('@/assets/images/mutilVehicle/temporary.png')}
                />
              )}
            </i>
            <span className="bg-bar">
              {vehicleData.takeOverUserName}于
              {TakeOverSourceText[vehicleData.takeOverSource]}
              {vehicleData.takeOverStatus === TakeOverStatus.TAKEOVER
                ? '接管中...'
                : '巡检停车中...'}
            </span>
          </div>
        )}
        {show && props.cockpitMode === CockpitMode.PATROL_MODE && (
          <div className="operation-container">
            {btnList.map((item) => {
              return <OperationBtn {...item} />;
            })}
          </div>
        )}
      </div>

      <div className="bottom-vehicleData-container">
        <div className="label-container">
          <div className="alarm-label-container">
            {vehicleData?.alarmEventList
              ?.slice(0, 3)
              ?.map((item: any, index: number) => {
                return <AlarmCard vehicleData={item} key={index} />;
              })}
            {Number(vehicleData.speed?.toFixed(1)) > 0 &&
              Number(vehicleData.speed?.toFixed(1)) < 2 && (
                <AlarmCard
                  vehicleData={{
                    reportTime: Date.now() - 60000,
                    alarmEvent: '低速行驶',
                  }}
                />
              )}
          </div>
          {!isEmpty(vehicleData.sceneList) && (
            <div className="scene-alarm-content">
              <img
                style={{ width: '27px', height: '27px' }}
                src={require('@/assets/images/mutilVehicle/location.png')}
              />
              {vehicleData?.sceneList?.map((item: any) => {
                return (
                  <span className="label" key={item}>
                    {sceneNameMap.get(item)}
                  </span>
                );
              })}
              <span className="label">场景</span>
            </div>
          )}
        </div>

        <div className="status-container">
          {props.cockpitMode !== CockpitMode.MAP_COLLECTION_MODE && (
            <>
              <FieldItem
                label={'速度：'}
                value={convertSpeedMsToKmh(vehicleData.speed, 1)}
                isActive={
                  Number(vehicleData.speed?.toFixed(1)) > 0 &&
                  Number(vehicleData.speed?.toFixed(1)) < 0.5 &&
                  vehicleData?.scheduleState &&
                  (stringToEnum(
                    VehicleScheduleState,
                    vehicleData.scheduleState
                  ) === VehicleScheduleState.SETOUT ||
                    stringToEnum(
                      VehicleScheduleState,
                      vehicleData.scheduleState
                    ) === VehicleScheduleState.RETURN)
                }
              />
              <FieldItem
                label={'模式：'}
                value={stringToEnum(VehicleState, vehicleData.vehicleState)}
              />
              <FieldItem
                label={'配送状态：'}
                value={
                  vehicleData?.scheduleState &&
                  stringToEnum(VehicleScheduleState, vehicleData.scheduleState)
                }
              />
              <FieldItem
                label={'里程：'}
                value={`${
                  vehicleData?.arrivedMileage
                    ? (vehicleData?.arrivedMileage / 1000).toFixed(1)
                    : '0.0'
                }/${
                  vehicleData?.globalMileage
                    ? (vehicleData?.globalMileage / 1000).toFixed(1)
                    : '0.0'
                }km`}
              />
            </>
          )}
          {props.cockpitMode === CockpitMode.MAP_COLLECTION_MODE && (
            <>
              <FieldItem
                label={IconLabel('speed')}
                value={convertSpeedMsToKmh(vehicleData.speed, 1)}
              />
              <FieldItem
                label={IconLabel('vehicleState')}
                value={stringToEnum(VehicleState, vehicleData.vehicleState)}
              />
              <FieldItem
                label={IconLabel('mileage')}
                value={`${
                  vehicleData?.arrivedMileage
                    ? (vehicleData?.arrivedMileage / 1000).toFixed(1)
                    : '0.0'
                }/${
                  vehicleData?.globalMileage
                    ? (vehicleData?.globalMileage / 1000).toFixed(1)
                    : '0.0'
                }km`}
              />
              <FieldItem
                label={IconLabel('bindingState')}
                value={vehicleData.bindingState ? '已绑定' : '未绑定'}
              />
              <FieldItem
                label={'电量：'}
                value={
                  vehicleData.power
                    ? parseInt(vehicleData.power.toString())
                    : '--'
                }
              />
            </>
          )}
        </div>
      </div>
      <Modal
        width={433}
        title="呼叫远驾"
        open={showModal}
        onOk={sendCallFrontCommand}
        onCancel={handleClose}
        onClose={handleClose}
        destroyOnClose
      >
        <CommonForm
          layout="vertical"
          config={formField}
          getFormInstance={(formRef: any) => {
            formInstance.current = formRef;
          }}
        />
      </Modal>
    </li>
  );
};

export default React.memo(VehicleCard);
